import { Component, Input, OnInit } from '@angular/core';
import { NewsContentPageSection } from 'src/app/model/section/news-content-page-section';

@Component({
  selector: 'app-news-content-page-section',
  templateUrl: './news-content-page-section.component.html',
  styleUrls: ['./news-content-page-section.component.scss']
})
export class NewsContentPageSectionComponent implements OnInit {
  @Input() sections: NewsContentPageSection[] = [];
  constructor() {}

  ngOnInit(): void {}
}
